import { CurrencyPipe } from '@angular/common';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChurchService } from 'src/app/church/church.service';
import { Church } from 'src/app/shared/interfaces/church.interface';
import { PatrimonyService } from '../patrimony.service';

@Component({
  selector: 'app-patrimony-form',
  templateUrl: './patrimony-form.component.html',
  styleUrls: ['./patrimony-form.component.css'],
})
export class PatrimonyFormComponent implements OnInit {
  form: FormGroup;
  id: number;
  churches: Church[] = [];

  constructor(
    private patrimoniService: PatrimonyService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private currency: CurrencyPipe,
    private churchService: ChurchService
  ) {
    this.churchService.get().then((res) => {
      this.churches = res;
    });

    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.get();
      }
    });

    this.form = new FormGroup({
      description: new FormControl('', [
        Validators.required,
        Validators.minLength(9),
      ]),
      acquisition_date: new FormControl('', [Validators.required]),
      type: new FormControl('', Validators.required),
      conservation_state: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required]),
      situation: new FormControl('', [Validators.required]),
      annotations: new FormControl(''),
      church_id: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {}

  add(): void {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.form.patchValue({
      value: this.form.get('value').value.replace(/\D/g, ''),
    });

    this.patrimoniService
      .add(this.form.value)
      .then((res) => {
        this.toastr.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('patrimonio');
      })
      .catch((err) => {
        this.toastr.error(err.massage || 'Falha ao salvar patrimônio');
      });
  }

  save(): Promise<any> {
    this.form.get('value').value.replace(/\D/g, '');
    if (!this.form.valid) {
      this.form.errors;
      return;
    }

    return this.patrimoniService
      .update(this.form.value, this.id)
      .then((res) => {
        this.toastr.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('patrimonio');
      })
      .catch((err) => {
        this.toastr.success(
          err.error.message || 'Patrimônio Alterado com sucesso!'
        );
      });
  }

  get(): Promise<any> {
    return this.patrimoniService.getById(this.id).then((res) => {
      const {
        acquisition_date,
        annotations,
        conservation_state,
        description,
        situation,
        type,
        value,
        church_id,
      } = res;
      let newValue = value.replace('.', ',');
      const formatedDate = acquisition_date.substr(0, 10);
      this.form.setValue({
        acquisition_date: formatedDate,
        annotations,
        conservation_state,
        description,
        situation,
        type,
        value: newValue,
        church_id,
      });
    });
  }
}
